// extracted by mini-css-extract-plugin
module.exports = {"googleBtn":"styles_googleBtn__b5dYT","googleIcon":"styles_googleIcon__tjNBX","googleBtnText":"styles_googleBtnText__tnjjL"};